import { getTextField } from '@lender/utils';
import { array, mixed, object } from 'yup';

import { HalcyonMethodEnum } from 'constants/loanActionEditor';

// IRS Account pre-authorization orders no transcripts, so the form pickers are hidden and
// must not be required.
export const checkIsPreAuthWithoutForms = (isPreAuthorization, methodValue) =>
  isPreAuthorization && methodValue === HalcyonMethodEnum.IRS_ACCOUNT;

// Requiredness is derived from live form state and the schema rebuilt on change, rather than
// a yup `.when('method', …)`: `method` is a getTextField() string schema, so yup casts the
// selected `{ value }` option to "[object Object]" before handing it to a `when` builder,
// leaving `method?.value` undefined and the IRS-Account branch permanently dead.
export const getHalcyonTaxTranscriptSchema = ({
  hasBorrowerOptions,
  areFormsHidden,
  isSpecificYears,
}) =>
  object().shape({
    method: getTextField(),
    forms: areFormsHidden
      ? array().notRequired()
      : array().min(1, 'At least one form is required').required('Forms can not be empty'),
    yearMode: areFormsHidden ? mixed().notRequired() : getTextField(),
    specificYears:
      !areFormsHidden && isSpecificYears
        ? array()
            .min(1, 'At least one year is required')
            .required('Specific Years can not be empty')
        : array().notRequired(),
    resubmitMode: getTextField(),
    authorizationSource: getTextField(),
    ...(hasBorrowerOptions
      ? {
          borrowers: array()
            .min(1, 'At least one borrower is required')
            .required('Borrowers can not be empty'),
        }
      : {}),
  });
